module.exports = __webpack_public_path__ + "img/campaign-step-3.7f1a6ade.jpg";